import { UnitOfTime } from '../model/schedulingModels/UnitOfTime';
import { Duration } from '../model/schedulingModels/Duration';
import { DayOfWeek } from '../model/schedulingModels/DayOfWeek';

const DEFAULT_ACTION_OFFSET: Duration = {
  value: 0,
  unit: UnitOfTime.S,
};

const DEFAULT_DAYS_OF_WEEK: DayOfWeek[] = ['MON', 'TUE', 'WED', 'THU', 'FRI', 'SAT', 'SUN'];

export class SchedulingConst {
  static DEFAULT_ACTION_OFFSET = DEFAULT_ACTION_OFFSET;
  static DEFAULT_DAYS_OF_WEEK = DEFAULT_DAYS_OF_WEEK;
}
